import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const MegaMenu = ({ isOpen, onClose }) => {
  const [activeCategory, setActiveCategory] = useState(0);
  
  const menuStructure = [
    {
      title: 'Trademark Services',
      items: [
        { 
          name: 'Register Your Trademark', 
          path: '/services/register-trademark',
          description: 'Secure brand rights with thorough searches and expert registration services.'
        },
        { 
          name: 'Clearance Search Services', 
          path: '/services/clearance-search',
          description: 'Ensure brand uniqueness with comprehensive clearance searches.'
        },
        { 
          name: 'Trademark Ownership Transfers', 
          path: '/services/trademark-transfers',
          description: 'Smoothly transfer trademark ownership with our expert guidance.'
        },
        { 
          name: 'Submission of Statements of Use', 
          path: '/services/statements-of-use',
          description: 'Compliantly file Statements of Use for active trademark status.'
        },
        { 
          name: 'Support and Response for Trademark Office Actions', 
          path: '/services/trademark-office-actions',
          description: 'Navigate challenges with strategic responses to trademark office actions.'
        },
        { 
          name: 'Active Monitoring for Trademark infringement', 
          path: '/services/trademark-monitoring',
          description: 'Vigilantly monitor trademarks to protect against potential infringements.'
        },
        { 
          name: 'File TTAB Petition', 
          path: '/services/ttab-petition',
          description: 'Trust us to handle your TTAB petition safely and professionally.'
        },
      ],
    },
    {
      title: 'Company Formation Services',
      items: [
        { 
          name: 'Limited Liability Company', 
          path: '/services/llc-formation',
          description: 'Form your LLC with complete legal protection and tax flexibility.'
        },
        { 
          name: 'C Corporation', 
          path: '/services/c-corporation',
          description: 'Establish a C Corporation for maximum growth and investment opportunities.'
        },
        { 
          name: 'S Corporation', 
          path: '/services/s-corporation',
          description: 'S Corporation formation with pass-through taxation benefits.'
        },
        { 
          name: 'Non-Profit', 
          path: '/services/non-profit',
          description: 'Create a tax-exempt non-profit organization dedicated to your cause.'
        },
      ],
    },
    {
      title: 'Copyright Services',
      items: [
        { 
          name: 'Register Your Copyright', 
          path: '/services/register-copyright',
          description: 'Protect your creative works with comprehensive copyright registration.'
        },
        { 
          name: 'Assistance for Your Copyright Enforcement', 
          path: '/services/copyright-enforcement',
          description: 'Defend your copyrights with professional enforcement support.'
        },
        { 
          name: 'Copyright Transfers and Licensing Support', 
          path: '/services/copyright-transfers',
          description: 'Expert guidance for copyright transfers and licensing agreements.'
        },
        { 
          name: 'Legal Representation for Your Copyright', 
          path: '/services/copyright-legal-representation',
          description: 'Professional legal representation for copyright matters.'
        },
        { 
          name: 'Management of Your Copyright Portfolio', 
          path: '/services/copyright-portfolio',
          description: 'Comprehensive management of your copyright portfolio.'
        },
        { 
          name: 'Compliance with DMCA Act', 
          path: '/services/dmca-compliance',
          description: 'Ensure compliance with the Digital Millennium Copyright Act.'
        },
      ],
    },
    {
      title: 'Patent Services',
      items: [
        { 
          name: 'Search for Existing Patent', 
          path: '/services/patent-search',
          description: 'Comprehensive patent searches to identify existing patents and prior art.'
        },
        { 
          name: 'Support and Response for Patent Office Actions', 
          path: '/services/patent-office-actions',
          description: 'Professional response to Patent Office actions and rejections.'
        },
        { 
          name: 'Application Submission for Patent', 
          path: '/services/patent-application',
          description: 'Complete patent application preparation and filing services.'
        },
        { 
          name: 'Legal Representation for Patent Protection', 
          path: '/services/patent-legal-representation',
          description: 'Expert legal representation for patent protection and enforcement.'
        },
      ],
    },
    {
      title: 'Legal Services',
      items: [
        { 
          name: 'Business Immigration Law', 
          path: '/services/business-immigration',
          description: 'Comprehensive business immigration legal services.'
        },
        { 
          name: 'Due Diligence Process', 
          path: '/services/due-diligence',
          description: 'Thorough due diligence for business transactions and investments.'
        },
        { 
          name: 'IT & Commercial Law', 
          path: '/services/it-commercial-law',
          description: 'Expert legal services for IT and commercial matters.'
        },
        { 
          name: 'Legal Services on Partnerships & LLPs', 
          path: '/services/partnerships-llp',
          description: 'Specialized legal services for partnerships and limited liability partnerships.'
        },
        { 
          name: 'Data Protection & Privacy Law', 
          path: '/services/data-protection',
          description: 'Comprehensive data protection and privacy law services.'
        },
      ],
    },
    {
      title: 'Additional Corporate Services',
      items: [
        { 
          name: 'Amazon Brand Registry in the US', 
          path: '/services/amazon-brand-registry',
          description: 'Complete Amazon Brand Registry registration and support services.'
        },
        { 
          name: 'Bookkeeping Service', 
          path: '/services/bookkeeping',
          description: 'Professional bookkeeping services to keep your finances organized.'
        },
        { 
          name: 'Business Formation Services', 
          path: '/services/business-formation',
          description: 'Complete business formation and entity structuring services.'
        },
        { 
          name: 'Certificate of Good Standing', 
          path: '/services/certificate-good-standing',
          description: 'Obtain certificates of good standing for your business.'
        },
        { 
          name: 'Company Dissolution', 
          path: '/services/company-dissolution',
          description: 'Professional assistance with company dissolution and closure.'
        },
        { 
          name: 'Company Name Change', 
          path: '/services/company-name-change',
          description: 'Legal services for changing your company name.'
        },
        { 
          name: 'Company Renewal Services', 
          path: '/services/company-renewal',
          description: 'Annual company renewal and compliance services.'
        },
        { 
          name: 'Issue Of Shares', 
          path: '/services/issue-of-shares',
          description: 'Professional services for issuing company shares.'
        },
        { 
          name: 'Nominee Director & Secretarial Services', 
          path: '/services/nominee-director',
          description: 'Nominee director and corporate secretarial services.'
        },
        { 
          name: 'Tax Advisory & Filing', 
          path: '/services/tax-advisory',
          description: 'Expert tax advisory and filing services for your business.'
        },
        { 
          name: 'Transfer of Shares', 
          path: '/services/transfer-of-shares',
          description: 'Legal assistance for transferring company shares.'
        },
        { 
          name: 'CFO Services', 
          path: '/services/cfo-services',
          description: 'Professional Chief Financial Officer services for growing businesses.'
        },
      ],
    },
  ];

  if (!isOpen) return null;

  return (
    <>
      {/* Mega Menu Container - Responsive Design */}
      <div 
        className="absolute left-1/2 transform -translate-x-1/2 top-full mt-2 z-50 w-[95vw] max-w-7xl bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200"
        data-testid="mega-menu-container"
      >
        {/* Desktop & Tablet Layout (768px+) */}
        <div className="hidden md:flex h-[500px]">
          {/* Left Sidebar - Categories */}
          <div className="w-48 lg:w-64 bg-gradient-to-b from-gray-50 to-gray-100 border-r border-gray-200 py-4 overflow-y-auto">
            {menuStructure.map((category, categoryIndex) => (
              <button
                key={categoryIndex}
                onClick={() => setActiveCategory(categoryIndex)}
                onMouseEnter={() => setActiveCategory(categoryIndex)}
                className={`w-full text-left px-4 lg:px-6 py-3 lg:py-4 flex items-center justify-between transition-all duration-200 group ${
                  activeCategory === categoryIndex
                    ? 'bg-gradient-to-r from-indigo-50 to-purple-50 border-l-4 border-indigo-600'
                    : 'hover:bg-white/80 border-l-4 border-transparent'
                }`}
                data-testid={`mega-menu-category-${categoryIndex}`}
              >
                <span className={`font-semibold text-sm lg:text-base ${
                  activeCategory === categoryIndex ? 'text-indigo-600' : 'text-gray-700'
                }`}>
                  {category.title}
                </span>
                <ChevronRight 
                  className={`transition-all ${
                    activeCategory === categoryIndex 
                      ? 'text-indigo-600 translate-x-1' 
                      : 'text-gray-400 group-hover:text-gray-600 group-hover:translate-x-1'
                  }`}
                  size={18} 
                />
              </button>
            ))}
          </div>

          {/* Right Content Area - Services */}
          <div className="flex-1 p-4 lg:p-8 overflow-y-auto custom-scrollbar bg-white">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-6">
              {menuStructure[activeCategory].items.map((item, itemIndex) => (
                <Link
                  key={itemIndex}
                  to={item.path}
                  onClick={onClose}
                  className="group block"
                  data-testid={`mega-menu-item-${activeCategory}-${itemIndex}`}
                >
                  <div className="space-y-1 lg:space-y-2">
                    <div className="flex items-start gap-2">
                      <ChevronRight 
                        className="text-indigo-500 flex-shrink-0 mt-0.5 group-hover:translate-x-1 transition-transform" 
                        size={16} 
                      />
                      <h4 className="text-gray-900 font-semibold text-sm lg:text-base group-hover:text-indigo-600 transition-colors leading-snug">
                        {item.name}
                      </h4>
                    </div>
                    <p className="text-gray-600 text-xs lg:text-sm leading-relaxed pl-5 lg:pl-6 line-clamp-2">
                      {item.description}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile Layout (below 768px) - Accordion Style */}
        <div className="md:hidden max-h-[70vh] overflow-y-auto custom-scrollbar">
          {menuStructure.map((category, categoryIndex) => (
            <div key={categoryIndex} className="border-b border-gray-200 last:border-b-0">
              <button
                onClick={() => setActiveCategory(activeCategory === categoryIndex ? null : categoryIndex)}
                className="w-full flex items-center justify-between px-4 py-4 bg-gradient-to-r from-gray-50 to-white hover:from-gray-100 hover:to-gray-50 transition-all"
              >
                <span className="font-semibold text-base text-gray-900">{category.title}</span>
                <ChevronRight 
                  className={`text-indigo-600 transition-transform ${
                    activeCategory === categoryIndex ? 'rotate-90' : ''
                  }`}
                  size={20} 
                />
              </button>
              {activeCategory === categoryIndex && (
                <div className="bg-white px-4 pb-4 space-y-2">
                  {category.items.map((item, itemIndex) => (
                    <Link
                      key={itemIndex}
                      to={item.path}
                      onClick={onClose}
                      className="block py-3 px-4 bg-gray-50 hover:bg-indigo-50 rounded-lg transition-all"
                    >
                      <h5 className="text-sm font-semibold text-gray-900 mb-1 flex items-start">
                        <ChevronRight className="text-indigo-500 flex-shrink-0 mr-2 mt-0.5" size={14} />
                        <span>{item.name}</span>
                      </h5>
                      <p className="text-xs text-gray-600 leading-relaxed pl-5">
                        {item.description}
                      </p>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
        
        {/* Bottom Gradient Bar */}
        <div className="h-1 bg-gradient-to-r from-purple-600 via-indigo-500 to-purple-600"></div>
      </div>

      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f3f4f6;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: linear-gradient(to bottom, #6366f1, #9333ea);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(to bottom, #4f46e5, #7c3aed);
        }
      `}</style>
    </>
  );
};

export default MegaMenu;
